import coffeeMen2039Img from "@/assets/images/landing_coffee_men2039.webp";
import coffeeMen40Img from "@/assets/images/landing_coffee_men40.webp";
import coffeeSapphicImg from "@/assets/images/landing_coffee_sapphic.webp";
import coffeeSapphic40Img from "@/assets/images/landing_coffee_sapphic40.webp";
import dinnerMen20Img from "@/assets/images/landing_m20.webp";
import dinnerMen40Img from "@/assets/images/landing_m40.webp";
import dinnerMen50Img from "@/assets/images/landing_m50.webp";
import dinnerSapphicImg from "@/assets/images/landing_sapphic.webp";
import dinnerWomen40Img from "@/assets/images/landing_w40.webp";

const QUIZ_MEN = "/img/quiz/quiz-community-male.webp";
const QUIZ_SAPPHIC = "/img/quiz/quiz-community-sapphic.webp";
const QUIZ_MIXED = "/img/quiz/quiz-community-mixed.webp";

export type GuidedAudience = "men" | "sapphic" | "mixed";

/** [front card, back-left card, back-right card] */
export type GuidedPhotoStack = [string, string, string];

/**
 * Which community photo set fits this user. Prefers the community they picked
 * during the quiz (mirrors the ad audience); otherwise infers from gender
 * identity, falling back to the mixed set whenever the answer is ambiguous.
 */
export function resolveGuidedAudience(profile: any): GuidedAudience {
  const community = profile?.community;
  if (community === "men" || community === "sapphic") return community;
  const gi = profile?.genderIdentity;
  const identities: string[] = Array.isArray(gi) ? gi : gi ? [gi] : [];
  const leansMen = identities.includes("cis_man") || identities.includes("trans_man");
  const leansSapphic =
    identities.includes("cis_woman") || identities.includes("trans_woman");
  if (leansMen && !leansSapphic) return "men";
  if (leansSapphic && !leansMen) return "sapphic";
  return "mixed";
}

/**
 * Photos for the guided booking card stack, front card first.
 *
 * Coffee events get café shots, everything else (dinner/brunch/drinks) gets
 * table shots, and each set is ordered so the closest age/audience match sits
 * on the front card while the two behind it stay on-theme. All creatives are
 * reused from the ad landings and quiz stepper so the screen looks like a
 * continuation of what the user just came through.
 */
export function pickGuidedPhotoStack(
  eventType: string,
  audience: GuidedAudience,
  age: number | null,
): GuidedPhotoStack {
  const older = age !== null && age >= 40;

  if (eventType === "coffee") {
    if (audience === "men") {
      return older
        ? [coffeeMen40Img, coffeeMen2039Img, QUIZ_MEN]
        : [coffeeMen2039Img, coffeeMen40Img, QUIZ_MEN];
    }
    if (audience === "sapphic") {
      return older
        ? [coffeeSapphic40Img, coffeeSapphicImg, QUIZ_SAPPHIC]
        : [coffeeSapphicImg, coffeeSapphic40Img, QUIZ_SAPPHIC];
    }
    return [coffeeSapphicImg, coffeeMen2039Img, QUIZ_MIXED];
  }

  if (audience === "men") {
    if (age !== null && age >= 50) return [dinnerMen50Img, dinnerMen40Img, QUIZ_MEN];
    if (older) return [dinnerMen40Img, dinnerMen50Img, QUIZ_MEN];
    return [QUIZ_MEN, dinnerMen20Img, dinnerMen40Img];
  }
  if (audience === "sapphic") {
    return older
      ? [dinnerWomen40Img, dinnerSapphicImg, QUIZ_SAPPHIC]
      : [QUIZ_SAPPHIC, dinnerSapphicImg, dinnerWomen40Img];
  }
  return [QUIZ_MIXED, dinnerSapphicImg, QUIZ_MEN];
}
